import type { EnvironmentType, GetEnvironmentsResponseV2 } from "@octopusdeploy/octopus-server-client";
import { Repository } from "@octopusdeploy/octopus-server-client";

export function getEnvironmentsForArgoCDApplications(repo: Repository, ephemeralEnvironmentsEnabled: boolean): Promise<GetEnvironmentsResponseV2> {
    const envTypes: EnvironmentType[] = ephemeralEnvironmentsEnabled ? ["Static", "Ephemeral"] : ["Static"];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return repo.Environments.getV2({ spaceId: repo.spaceId!, skip: 0, take: Repository.takeAll, type: envTypes });
}
